import { combineReducers } from 'redux';

import roster from 'components/roster-portal/reducers';

import {
  userDetails,
  preferences,
  grants,
  organisationPreferences,
  planGroups,
  planUnits,
  employeePlanUnits,
  publicPlanUnits,
  dutyCodes,
  dhts,
  holidays,
  workAgreements
} from './commonReducers';

export default combineReducers({
  roster,
  userDetails,
  preferences,
  grants,
  organisationPreferences,
  planGroups,
  planUnits,
  employeePlanUnits,
  publicPlanUnits,
  dutyCodes,
  dhts,
  holidays,
  workAgreements
});
